import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DataGridColumnDefinition } from 'components';
import { AppConfigArea, AppConfigKey, FilterDefinitionType } from 'enums';
import { useP2PProvidersConfig } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { AppConfig, AppConfigFilters, FilterDefinition } from 'types';
import { appConfigUtils, p2pProviderUtils } from 'utils';

import { ConfigsPageTab } from '../ConfigsPageTab';

export const PayoutP2PProvidersTab: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.configs',
  });

  const additionalColumns = useMemo(
    (): DataGridColumnDefinition<AppConfig>[] => [
      {
        header: t('fields.provider'),
        valueKey: 'p2pProviderType',
        valueFormatter: p2pProviderUtils.getTypeLabel,
      },
    ],
    [t],
  );
  const { availableP2PProviderTypeOptions } = useP2PProvidersConfig();

  const additionalFilters: FilterDefinition<AppConfigFilters>[] = useMemo(
    () => [
      {
        label: t('fields.provider'),
        name: 'p2pProviderType',
        type: FilterDefinitionType.Select,
        options: availableP2PProviderTypeOptions,
        getDisplayName: p2pProviderUtils.getTypeLabel,
      },
      {
        label: t('fields.key'),
        name: 'key',
        type: FilterDefinitionType.Enum,
        enum: [AppConfigKey.BanksMap, AppConfigKey.PaymentTypeMap],
        getDisplayName: appConfigUtils.getKeyLabel,
      },
    ],
    [availableP2PProviderTypeOptions, t],
  );

  return (
    <ConfigsPageTab
      area={AppConfigArea.PayoutP2PProvider}
      additionalColumns={additionalColumns}
      additionalFilters={additionalFilters}
    />
  );
};
